import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../service/common.service';
import { ShareService } from '../service/share.service';
import { AdminshareService } from "../service/adminshare.service";
import { ActivatedRoute, Router, RouterEvent, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AViewTextModalComponent } from '../a0106-mail/a-view-text-modal.component';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';
import { YoyakuMasterService } from '../service/ymaster.service';

@Component({
    selector: 'ydivision2-app',
    templateUrl: './ydivision2.component.html',
    styleUrls: ['ydivision2.component.css']
})
export class YDivision2Component implements OnInit {
    @Input() event_id: number;
    title = '区分２';
    selected_division_1_id: number = null;
    page: number = 1;
    all_count: number = 0;
    display_per_page: number = 20;   /* 最大表示件数 */
    isLoaded: boolean = false;
    selected: boolean = false;
    datalist: any = [];
    all_datalist: any = [];
    selectedList: any = [];
    outputClassList: any = [];
    event: any = [];
    division_1:any =[];
    selectmode: boolean = true;
    selected_event_id: number = null;
    tempSelectedRow: any;
    ROLE: any = Role;
    languagelist : any = [];
    selected_language_id : number = null;
    content_list_division2_info: any = {
        'name_name': 'タイトル',
        'name_description': '説明文',
        'name_support': 'タイトルを入力してください',
        'description_support': '説明文を入力してください',
        'data': {},
        'languagelist': [],
    };
    private previousUrl: string = undefined;
    private currentUrl: string = undefined;
    constructor(
        private commonService: CommonService,
        private shareService: ShareService,
        private adminShareService: AdminshareService,
        public usersService: UsersService,
        private modalService: NgbModal,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private yoyakumasterService: YoyakuMasterService,
    ) { }

    ngOnInit(): void {
        this.selected_division_1_id = +this.route.snapshot.paramMap.get('did');
        this.getList();
        //Loading停止　→　仮で入れています。getList処理を作る時に消してください
        // this.commonService.loadingEnd();
        //画面上部へ移動
        window.scrollTo(0, 0);
    };

    clearData(): void {
        this.isLoaded = false;
        this.selected = false;
        this.datalist = [];
        this.languagelist = [];
    }

    getList(): void {
        this.clearData();
        this.yoyakumasterService.getDivision2(this.selected_division_1_id)
            .subscribe((res: Response) => {
                if (res["fuel_status"] == "OK") {
                    this.division_1 = res["fuel_results"]["division_1"];
                    this.content_list_division2_info.languagelist = res["fuel_results"]['language'];
                   
                    if (this.division_1.length==0){
                      //対象の区分１がないメッセージを表示し、区分１の画面へ飛ばす
                      this.commonService.modalOpens(11007,modalresult=>{
                          this.router.navigate(["/ydivision1"]);
                          });
                        }else{
                        }
                
                    this.all_datalist = res["fuel_results"]["division_2"];
                    this.all_count = res["fuel_results"]["all_count"];

                    // for (let i = 0; i < this.all_datalist.length; i++) {
                    //     this.all_datalist[i]['db_selected'] = this.commonService.exchange01toTF(this.all_datalist[i]['selected']);
                    //     this.all_datalist[i]['disabled'] = this.commonService.exchange01toTF(this.all_datalist[i]['disabled']);
                    // }

                    this.isLoaded = true;

                }else if (res["fuel_status"] == "NG") {
                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                }else{
                    this.commonService.modalOpens(11003,modalresult=>{});
                }
            },error => {
                this.commonService.modalOpens(error,modalresult=>{});
            });
        }

    
    save(): void {
        this.commonService.modalOpens(50001,
            //保存してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.yoyakumasterService.saveDivision2(this.content_list_division2_info.data)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10001, modalresult => { });
                                this.editSelectRowData(undefined);
                                this.selected = false;
                                this.page = 1;
                                this.getList();
                            } else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                            } else {
                                this.commonService.modalOpens(11003, modalresult => { });
                            }
                        }, error => {
                            this.commonService.modalOpens(error, modalresult => { });
                        });
                } else {
                    //
                }
            }
        );
    }
    

    cancel(): void {
        this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.editSelectRowData(undefined);
                    this.selected = false;
                } else {

                }
            }
        );
    }
    delete(): void {
        this.commonService.modalOpens(50002,
            //削除してもよろしいですか？
            modalresult => {
                if (modalresult == "OK") {
                    this.yoyakumasterService.deleteDivision2(this.content_list_division2_info.data)
                        .subscribe((res: Response) => {
                            if (res["fuel_status"] == "OK") {
                                this.commonService.modalOpens(10002, modalresult => {
                                    this.selectedList = this.selectedList.filter(
                                        item =>
                                            item.m_division_2_id != this.content_list_division2_info.data.m_division_2_id
                                    );
                                    this.editSelectRowData(undefined);
                                    this.selected = false;
                                    this.page = 1;
                                    this.getList();
                                });
                            } else if (res["fuel_status"] == "NG") {
                                this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                            } else {
                                this.commonService.modalOpens(11003, modalresult => { });
                            }
                        }, error => {
                            this.commonService.modalOpens(error, modalresult => { });
                        });
                } else {

                }
            }
        );
    }
    // // 編集
    edit(row: any): void {
        if (this.selected) {
            this.commonService.modalOpens(50005,
                //編集中の内容を破棄してもよろしいですか？
                modalresult => {
                    if (modalresult == "OK") {
                        this.editSelectRowData(row);
                        //画面上部へ移動
                        window.scrollTo(0, 0);

                    } else {
                        return;
                    }
                }
            );
        } else {
            this.editSelectRowData(row);
            //画面上部へ移動
            window.scrollTo(0, 0);
        }
    }

    editSelectRowData(row: any): void {
        if (row == undefined) {
            if(this.division_1.length>0){
                var lang_content =[];
                for (let i= 0; i < this.division_1.length; i++){
                    lang_content[lang_content.length]
                    = {
                        m_language_id:this.division_1[i]['m_language_id'],
                        c_name: null,
                        c_short: null,
                    };
                }
            }
            this.selected = true;
            this.content_list_division2_info.data = {
                id: null,
                d_1_id:this.selected_division_1_id,
                code: null,
                update_datetime: null,
                sort: null,
                content: lang_content,
            };
         }else{
            this.selected = true;
            this.content_list_division2_info.data = JSON.parse(JSON.stringify(row));
             }       
        }
    

    

    upRow(row: number, data: any): void {
        let tempdatalist;
        tempdatalist = this.all_datalist;

        if (row == 0) {//最初

        } else {
            //自分のレコード　myRecord
            let myRecord = tempdatalist[row];
            //１つ前のレコード beforeRecord
            let beforeRecord = tempdatalist[row - 1];
            // 旧sortを退避
            myRecord['chk_sort'] = myRecord['sort'];
            beforeRecord['chk_sort'] = beforeRecord['sort'];

            //sortnoを交換する
            let tmpsort = myRecord['sort'];
            myRecord['sort'] = beforeRecord['sort'];
            beforeRecord['sort'] = tmpsort;

            //２レコードをUPDATEする　myRecord,beforeRecord
            this.yoyakumasterService.changeOrderDivision2([myRecord, beforeRecord])
                .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        tempdatalist.splice(row - 1, 2, tempdatalist[row], tempdatalist[row - 1]);
                    } else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                    } else {
                        this.commonService.modalOpens(11003, modalresult => { });
                    }
                }, error => {
                    this.commonService.modalOpens(error, modalresult => { });
                });
        }
    }
    downRow(row: number, data: any): void {
        let tempdatalist;
        tempdatalist = this.all_datalist;

        if (row == tempdatalist.length - 1) {//最終

        } else {
            //１つ後ろのレコード afterRecord
            let afterRecord = tempdatalist[row + 1];
            //自分のレコード　myRecord
            let myRecord = tempdatalist[row];
            // 旧sortを退避
            myRecord['chk_sort'] = myRecord['sort'];
            afterRecord['chk_sort'] = afterRecord['sort'];
            //sortnoを交換する
            let tmpsort = myRecord['sort'];
            myRecord['sort'] = afterRecord['sort'];
            afterRecord['sort'] = tmpsort;

            //２レコードをUPDATEする　myRecord,afterRecord
            this.yoyakumasterService.changeOrderDivision2([myRecord, afterRecord])
                .subscribe((res: Response) => {
                    if (res["fuel_status"] == "OK") {
                        tempdatalist.splice(row, 2, tempdatalist[row + 1], tempdatalist[row]);
                    } else if (res["fuel_status"] == "NG") {
                        this.commonService.modalOpens(res["fuel_message"], modalresult => { });
                    } else {
                        this.commonService.modalOpens(11003, modalresult => { });
                    }
                }, error => {
                    this.commonService.modalOpens(error, modalresult => { });
                });
        }
    }
    check() {
        if (this.selected == true) {
            return true
        } else {
            return false
        }
    }
    checkList(): boolean {

        var tempList = this.content_list_division2_info.data;
        var row = tempList.content.filter(
            item =>
                item.m_language_id == null
                || item.c_name == null
                || item.c_name == ""
                || item.c_name.length > 50
                || item.c_short == null
                || item.c_short == ""
                || item.c_short.length > 50
        );
        if (row.length > 0) {
            return true;
        }
        if (this.content_list_division2_info.data.d_code == null
            || this.content_list_division2_info.data.d_code == "" 
            || this.content_list_division2_info.data.d_code.length > 8) {
            return true;
        }
        //CODEの重複がないか
        let dupcodecheckList = this.commonService.checkDatalistRecords(this.all_datalist, 'd_code','id',this.content_list_division2_info.data);
        //新規の時、CODEがthis.all_datalistにあればNG
        if (this.content_list_division2_info.data.id == null) {
            if (dupcodecheckList.length > 0) {
                return true;
            } 
        } else {
        //修正の時、CODEがthis.all_datalistに１つ以上あればNG
            if (dupcodecheckList.length >= 1) {
                return true;
            } 
        }
        //言語数以上登録されていないか
        if (this.content_list_division2_info.languagelist.length < tempList.content.length) {
            return true;
        } else {
            //言語IDが複数ないか
            let dupcheckList = this.commonService.checkDuplicateRecords(tempList.content,'m_language_id');
            if (dupcheckList.length < tempList.content.length){
                return true;
            }else{
                return false;
            }
        }
        
    }


    goBack(): void {
        if (this.selected) {
            this.commonService.modalOpens(50005,
                //編集中の内容を破棄してもよろしいですか？
                modalresult => {
                    if (modalresult == "OK") {
                        this.location.back();
                    }
                }
            );
        } else {
            this.location.back();
        }
    }
}
 


// WEBPACK FOOTER //
// ./src/app/a2124-ydivision2/ydivision2.component.ts